var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"pa-0":"","fluid":""}},[_c('v-layout',{attrs:{"column":""}},[_c('showcase',{attrs:{"id":"showcase"}}),_c('work',{attrs:{"id":"work"}}),_c('skills',{attrs:{"id":"skills"}}),_c('about',{attrs:{"id":"about"}}),_c('contact',{attrs:{"id":"contact"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }